import { createAction, handleActions } from 'redux-actions';
import createRequestSaga, {
  createRequestActionTypes,
} from '../../lib/createRequestSaga';
import { takeLatest } from 'redux-saga/effects';

import * as techApi from '../../lib/api/tech';

const [
  LIST_REQ_TECHS,
  LIST_REQ_TECHS_SUCCESS,
  LIST_REQ_TECHS_FAILURE,
] = createRequestActionTypes('tech/LIST_REQ_TECHS');

export const listReqTechs = createAction(
  LIST_REQ_TECHS,
  (searchData) => (searchData),
);
const listReqTechsSaga = createRequestSaga(
  LIST_REQ_TECHS,
  techApi.getReqTechs,
);

const UNLOAD_REQ_TECHS = 'tech/UNLOAD_REQ_TECHS';
export const unloadReqTechs = createAction(UNLOAD_REQ_TECHS);

export function* ReqTechsSaga() {
  yield takeLatest(LIST_REQ_TECHS, listReqTechsSaga);
}

const initialState = {
  techs: null,
  error: null,
};

const reqTechs = handleActions(
  {
    [LIST_REQ_TECHS_SUCCESS]: (state, { payload: data }) => ({
      ...state,
      techs: data.list.map((tech) => ({
        id: tech.reqUuid,
        reqUuid: tech.reqUuid,//요청서번호
        prjUuid: tech.prjUuid,
        planUuid:tech.planUuid,
        rsltUuid:tech.rsltUuid,
        reqNo: tech.reqNo, //reqNo
        reqGrade: tech.reqGrade,
        reqStatus: tech.reqStatus,
        custNm: tech.custNm,
        custEmpNm:tech.custEmpNm,//담당자명
        workTyp:tech.workTyp,
        workStDt: tech.workStDt,
        workEdDt: tech.workEdDt,
        workEmpNm:tech.workEmpNm,
        useYn:tech.useYn,
        crtNm:tech.crtNm,
        crtDt:tech.crtDt,
        cngNm:tech.cngNm,
        cngDt:tech.cngDt,
      })),
      error: null,
    }),
    [LIST_REQ_TECHS_FAILURE]: (state, { payload: error }) => ({
      ...state,
      error: error,
    }),
    [UNLOAD_REQ_TECHS]: () => initialState,
  },
  initialState,
);

export default reqTechs;
